import { motion } from "framer-motion";
import LucideIcon from "utils/LucideIcon";

const SectionOurVision = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut" as const,
      },
    },
  };

  return (
    <>
      <section className="pb-20 px-4">
        {/* Vision Section */}
        <motion.section
          className="flex flex-col lg:flex-row lg:items-center lg:gap-8"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={containerVariants}
        >
          <div className="md:mb-0 col-span-2 w-full">
            <motion.h2
              variants={itemVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
            >
              <div className="flex items-center md:text-left justify-center md:justify-start mb-4">
                {/* <Zap className="w-10 h-10 text-blue-900 mr-3 hidden md:inline-block" /> */}
                <LucideIcon
                  name="Eye"
                  className="w-10 h-10 text-blue-900 hover:text-blue-900 hidden md:inline-block mr-3"
                />
                <h2 className="text-4xl md:text-5xl font-bold font-inter text-secondary-gradient bg-clip-text text-transparent">
                  Our Vision
                </h2>
              </div>
            </motion.h2>
            <motion.div
              className="w-24 h-1 bg-secondary-gradient mx-auto md:mx-0 md:ml-14 mb-8 rounded-xl"
              initial={{ width: 0 }}
              whileInView={{ width: 96 }}
              transition={{ duration: 0.8, delay: 0.5 }}
              viewport={{ amount: 0.2 }}
            ></motion.div>
          </div>

          <motion.div
            className="max-w-5xl mx-auto col-span-4"
            variants={itemVariants}
          >
            <div className="relative">
              <motion.div
                className="absolute left-1 xl:left-5 2xl:left-8 top-0 w-1 h-full bg-secondary-gradient rounded-full"
                initial={{ height: 0 }}
                whileInView={{ height: "100%" }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ amount: 0.2 }}
              />

              <div className="ml-8 md:ml-12 xl:ml-16 relative">
                <motion.div
                  className="prose prose-lg max-w-none"
                  variants={itemVariants}
                >
                  <p className="text-xl text-gray-700 leading-relaxed font-body">
                    We envision a world where{" "}
                    <span className="font-semibold text-purple-600">
                      every identity is celebrated
                    </span>{" "}
                    and expression feels effortless. With{" "}
                    <span className="font-semibold text-green-600">
                      accessibility, consistency, and pride,
                    </span>{" "}
                    we empower everyone to express themselves with{" "}
                    <span className="font-semibold text-indigo-600">
                      clarity and confidence
                    </span>
                    .
                  </p>
                </motion.div>{" "}
              </div>
            </div>
          </motion.div>
        </motion.section>
      </section>
    </>
  );
};

export default SectionOurVision;
